import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { QuotationLayoutComponent } from "./quotation-layout.component";
import { QuotationBreadcrumbModule } from "../breadcrumb/quotation-breadcrumb.module";

@NgModule({
    imports: [
        CommonModule,
        QuotationBreadcrumbModule,
    ],
    exports: [
        QuotationLayoutComponent
    ],
    declarations: [
        QuotationLayoutComponent
    ],
})
export class QuotationLayoutModule {
}
